<style>
#eventBrowserModal .v--modal-box.v--modal {
  min-width: 410px;
  min-height: 180px;
}
#eventBrowserModal .v-text-field__slot label,
#eventBrowserModal .v-text-field__slot input {
  font-size: 12px;
}
#eventBrowserModal .modal__footer {
  display: none;
}
#eventBrowserModal *:not(.v-icon) {
  font-size: 12px;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="eventBrowserModal"
      title="Przeglądarka zdarzeń"
      :buttons="['']"
      :register="register"
      @opened="getUsers"
    >
      <div>
        <span>W celu zobaczenia wszystkich zdarzeń, wybierz użytkownika z poniższej listy:</span>
        <v-flex
          xs12
          d-flex
          class="modalSelect__layout"
          id="modalSelect__content"
        >
          <v-select
            :items="users"
            item-text="name"
            placeholder="Wybierz użytkownika"
            no-data-text="Brak dostępnych użytkowników"
            attach="#modalSelect__content"
            :return-object="true"
            height="16"
            v-model="eventUser"
          ></v-select>
        </v-flex>
      </div>
      <EventsTable v-if="eventUser" />
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../../shared/Modal";
import EventsTable from "../../../table/EventsTable";

export default {
  components: {
    Modal,
    EventsTable
  },
  data: () => ({
    register: true
    // currentUser: undefined
  }),
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    userEvents() {
      // Events for current user
      return this.$store.getters.getEvents;
    },
    eventUser: {
      // User chosen to get events for
      get() {
        return this.$store.getters.getEventUser;
      },
      set(value) {
        this.$store.commit("setEventUser", value);
        this.getUserEvents();
      }
    }
  },
  methods: {
    getUsers() {
      this.$store.commit("setEventUser", undefined);
      this.$store.dispatch("getUsers").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania listy użytkowników"
          );
        }
      });
    },
    getUserEvents() {
      let payload = {
        user: this.eventUser.id,
        limit: 30
      };
      this.$store.dispatch("getEvents", payload).then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania listy zdarzeń dla użytkownika"
          );
        } else {
          if(r.data.events.length == 0) {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Brak zdarzeń dla podanego użytkownika"
            );
            this.$root.$emit("showNoRowsMessage");
            return;
          } else {
            this.$root.$emit("refreshUserEvents");
          }
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/eventBrowser/EventBrowser.vue